import { getData, putData } from "../axiosConfig"

export const getCommission = async () => {
    return await getData(`admin/settings`)
}

export const updateCommission = async (id, body) => {
    return await putData(`admin/settings/${id}`, body)
}

export const orders = async () => {
    return await getData(`admin/shopify-order`)
}

export const archiveOrders = async () => {
    return await getData(`/admin/shopify-order/archive-orders`)
}

export const getUserWithDrawableTranaction = async (id) => {
    return await getData(`admin/withdrawl-request/${id}`)
}

export const headerNotification = async () => {
    return await getData(`admin/unapprovedPayments`)
}


